import { Image } from './Image';

export const AlternativeHeaderMock: Image[] = [
  { src: '/assets/alternative-header/image-1.jpg'},
  { src: '/assets/alternative-header/image-2.jpg'},
  { src: '/assets/alternative-header/image-3.jpg'}
];
